import Vue from 'vue'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue'
import router from './router'
import store from './store'

// Filters
import CurrencyFilter from '@/filters/currency';
import { DateOnlyFilter } from '@/filters/datetime';

require('./styles/main.css')
Vue.config.productionTip = false

Vue.component('Navbar', require('./components/Navbar.vue').default)
Vue.filter('currency', CurrencyFilter)
Vue.filter('dateonly', DateOnlyFilter);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
